import React, { useContext, useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import { AuthContext } from '../App';

/**
 * Wrap a route element. If the org's feature flag for `feature` is off,
 * redirect to /dashboard and show a toast. Dashboard, account and portal
 * routes should never be wrapped.
 */
export default function FeatureGuard({ feature, children, fallback = '/dashboard' }) {
  const { featureFlags, user } = useContext(AuthContext);
  const warnedRef = useRef(false);

  const disabled = featureFlags && user?.role !== 'client' && featureFlags[feature] === false;

  useEffect(() => {
    if (disabled && !warnedRef.current) {
      warnedRef.current = true;
      toast.error(`This feature is not included in your plan. Contact your administrator to enable it.`);
    }
  }, [disabled]);

  if (featureFlags === null) return null; // still loading
  if (disabled) return <Navigate to={fallback} replace />;
  return children;
}
